export default "__VITE_ASSET__B$9b8DMi__"